import { JsonSchema7 } from '@/components/SchemaEditor/JsonSchema';
import { OpenAIFunction } from '@/utils/ai-tools';

import { StructuredPromptSchema } from '../../components/manifest/serialized/prompts/ManifestStructuredPrompt';
import { DEFAULT_TOOL_PROPERTIES } from '../constants';

// we transform the tool schema into a StructuredPromptSchema to use this editor
// the only difference is the parameters key is spread at the top level
// and 'name' is called 'title'
export const convertToolToStructuredPromptSchema = (
  mFunction: OpenAIFunction,
  isEditingExisting: boolean
): StructuredPromptSchema => {
  const properties = (mFunction.parameters as JsonSchema7).properties ?? {};
  return {
    title: mFunction.name ?? '',
    description: mFunction.description ?? '',
    properties: isEditingExisting ? properties : DEFAULT_TOOL_PROPERTIES,
    required: (mFunction.parameters as JsonSchema7).required ?? [],
    type: (mFunction.parameters as JsonSchema7).type as string,
    strict: (mFunction as JsonSchema7).strict,
  };
};

export function convertStructuredPromptSchemaToTool(
  structuredPromptSchema: StructuredPromptSchema
): OpenAIFunction {
  const valueSchema = structuredPromptSchema as JsonSchema7;
  const strict = valueSchema.strict;
  return {
    name: valueSchema?.title,
    description: valueSchema?.description,
    parameters: {
      properties: valueSchema.properties,
      required: strict
        ? Object.keys(valueSchema.properties ?? {})
        : valueSchema.required,
      type: valueSchema.type,
      additionalProperties: !strict,
    },
    strict,
  };
}
